/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttendanceEntryRequest } from './AttendanceEntryRequest';
import {
    AttendanceEntryRequestFromJSON,
    AttendanceEntryRequestFromJSONTyped,
    AttendanceEntryRequestToJSON,
    AttendanceEntryRequestToJSONTyped,
} from './AttendanceEntryRequest';

/**
 * 
 * @export
 * @interface PlanWeeklyAttendanceRequest
 */
export interface PlanWeeklyAttendanceRequest {
    /**
     * 
     * @type {Date}
     * @memberof PlanWeeklyAttendanceRequest
     */
    weekStart: Date;
    /**
     * 
     * @type {string}
     * @memberof PlanWeeklyAttendanceRequest
     */
    originTimeZoneId: string;
    /**
     * 
     * @type {Array<AttendanceEntryRequest>}
     * @memberof PlanWeeklyAttendanceRequest
     */
    entries: Array<AttendanceEntryRequest>;
}

/**
 * Check if a given object implements the PlanWeeklyAttendanceRequest interface.
 */
export function instanceOfPlanWeeklyAttendanceRequest(value: object): value is PlanWeeklyAttendanceRequest {
    if (!('weekStart' in value) || value['weekStart'] === undefined) return false;
    if (!('originTimeZoneId' in value) || value['originTimeZoneId'] === undefined) return false;
    if (!('entries' in value) || value['entries'] === undefined) return false;
    return true;
}

export function PlanWeeklyAttendanceRequestFromJSON(json: any): PlanWeeklyAttendanceRequest {
    return PlanWeeklyAttendanceRequestFromJSONTyped(json, false);
}

export function PlanWeeklyAttendanceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanWeeklyAttendanceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'weekStart': (new Date(json['weekStart'])),
        'originTimeZoneId': json['originTimeZoneId'],
        'entries': ((json['entries'] as Array<any>).map(AttendanceEntryRequestFromJSON)),
    };
}

export function PlanWeeklyAttendanceRequestToJSON(json: any): PlanWeeklyAttendanceRequest {
    return PlanWeeklyAttendanceRequestToJSONTyped(json, false);
}

export function PlanWeeklyAttendanceRequestToJSONTyped(value?: PlanWeeklyAttendanceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'weekStart': `${value['weekStart'].getFullYear()}-${String(value['weekStart'].getMonth()+1).padStart(2,'0')}-${String(value['weekStart'].getDate()).padStart(2,'0')}`,
        'originTimeZoneId': value['originTimeZoneId'],
        'entries': ((value['entries'] as Array<any>).map(AttendanceEntryRequestToJSON)),
    };
}

